import { render, staticRenderFns } from "./FlowListStatistics.vue?vue&type=template&id=f6434cdc&"
import script from "./FlowListStatistics.vue?vue&type=script&lang=js&"
export * from "./FlowListStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports